<template>
  <div class="login">
    <div class="login-bg"></div>
    <div class="login-content">
      <header class="login-header">
        <div class="logo hand" @click="navTo('/')">
          <img src="http://ylxh-service.oss-cn-hangzhou.aliyuncs.com/logo.png" alt="" class="logo-img" />
        </div>
        <div class="menu-content">
          <div class="menu-item"
              v-for="(item, index) in menus"
              :key="index"
              @click="navTo(item.uri)">{{item.name}}</div>
        </div>
      </header>
      <div class="login-main">
        <h2 class="login-title" v-if="operateType != 'resetPwd'">欢迎{{mainText}}</h2>
        <h2 class="login-title" v-if="operateType == 'resetPwd'">重置密码</h2>
        <div class="login-form"  v-if="operateType == 'login'">
          <div>
            <div class="login-form-label">账号</div>
            <div class="login-form-item">
              <input type="text" placeholder="请输入账号" v-model="account" />
            </div>
          </div>
          <div>
            <div class="login-form-label">密码</div>
            <div class="login-form-item">
              <input type="password" placeholder="请输入密码" v-model="password" />
            </div>
          </div>
        </div>
				<div class="login-form" v-if="operateType == 'register'">
					<div>
					  <div class="login-form-label">手机号</div>
					  <div class="login-form-item">
					    <input type="text" placeholder="请输入手机号" v-model="phone" />
					  </div>
					</div>
					<div>
					  <div class="login-form-label">验证码</div>
					  <div class="login-form-item">
					    <input type="text" placeholder="请输入验证码" v-model="verificationCode" />
					    <div class="code-box hand" :class="tm ? 'disabled' : ''" @click="sendCode">{{codeText}}{{tm ? '秒后重发' : ''}}</div>
					  </div>
					</div>
				</div>
        <div class="login-form" v-if="operateType == 'resetPwd'">
					<div>
					  <div class="login-form-label">账号</div>
					  <div class="login-form-item">
					    <input type="text" placeholder="请输入账号" v-model="resetPwdAccount" />
					  </div>
					</div>
					<div>
					  <div class="login-form-label">验证码</div>
					  <div class="login-form-item">
					    <input type="text" placeholder="请输入验证码" v-model="resetPwdVerificationCode" />
					    <div class="code-box hand" :class="tm ? 'disabled' : ''" @click="sendResetPwdVerificationCode">{{codeText}}{{tm ? '秒后重发' : ''}}</div>
					  </div>
					</div>
				</div>
        <div class="login-submit">
          <div class="login-submit-btn" @click="onSubmit">{{mainText}}</div>
          <div class="login-submit-extra" v-if="operateType == 'login'">
            <div class="login-extra-row">
              <div class="login-remeber hand" @click="toggleCheck">
                <div class="sign-check" :class="checked ? 'checked' : ''"></div>
                记住密码
              </div>
              <div class="login-forget hand" @click="showForgetTip">忘记密码</div>
            </div>
            <div class="login-register-links">
              <span class="login-forget hand" @click="navTo('/member/group/register')">注册团体会员</span>
              <span class="login-forget hand" @click="navTo('/member/person/register')">注册个人会员</span>
            </div>
          </div>
          <div class="login-submit-extra login-submit-extra--simple" v-if="operateType == 'register' || operateType == 'resetPwd'">
            <div class="login-forget hand" @click="toggleStatus('login')">去登录</div>
          </div>
        </div>
      </div>
      <div class="login-footer">
        Copyright © 2022-2025 浙江省风景园林学会  <a href="http://beian.miit.gov.cn/" target="_blank" >浙ICP备2022029097号-1</a>
      </div>
    </div>

    <div class="forget-tip-mask" v-if="forgetTipVisible" @click.self="forgetTipVisible = false">
      <div class="forget-tip-modal">
        <div class="forget-tip-icon"></div>
        <div class="forget-tip-title">忘记密码</div>
        <div class="forget-tip-desc">请致电学会办公室</div>
        <div class="forget-tip-phone">0571-87999751 / 88832250</div>
        <button class="forget-tip-btn" type="button" @click="forgetTipVisible = false">我知道了</button>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router';
import { login, register, sendCode,sendResetPwdVerificationCode,resetPwd } from './service/api';
import { mapActions } from 'vuex';
const phoneReg = /^(13|15|17|18|14)[0-9]{9}$/;

export default {
  data() {
    return {
      menus: [{
        uri: '/',
        name: '首页'
      }, {
        uri: '/member',
        name: '会员之家'
      }, {
        uri: '/activity',
        name: '学会活动'
      }, {
        uri: '/publish',
        name: '编辑出版'
      }, {
        uri: '/education',
        name: '科普百科'
      }],
      checked: false,
      isRegister: router.currentRoute.query.register,
      operateType:'login',
      account: '',
      password: '',
			phone: '',
			verificationCode: '',
      resetPwdAccount:'',
      resetPwdVerificationCode:'',
			codeText: '获取验证码',
			tm: null,
      forgetTipVisible: false,
    }
  },
  computed: {
    mainText() {
      if(this.operateType == 'login'){
        return '登录';
      }else if(this.operateType == 'register'){
        return '注册';
      }else if(this.operateType == 'resetPwd'){
        return '提交';
      }else{
        return '';
      }
    }
  },
  mounted() {
    const username = localStorage.getItem('username');
    const password = localStorage.getItem('password');
    if (username && password) {
      this.account = username;
      this.password = password;
    }
  },
  methods: {
    ...mapActions(['getUserInfo']),
    navTo(uri) {
      router.push(uri);
    },
    toggleCheck() {
      this.checked = !this.checked;
    },
    toggleStatus(status) {
      this.operateType = status;
      // this.isRegister = !!status;
    },
    showForgetTip() {
      this.forgetTipVisible = true;
    },
		sendCode() {
			if (this.tm) return false;
			if (!this.phone) {
				return this.$message({
				  type: 'error',
				  content: '请输入手机号'
				})
			};
			if (!phoneReg.test(this.phone))
				return this.$message({
					type: 'error',
					content: '手机号不合法'
				})
			sendCode({
				phone: this.phone
			}).then(() => {
				this.codeText = 60;
				this.tm = setInterval(() => {
					--this.codeText;
					if (this.codeText === 0) {
						this.codeText = '获取验证码';
						clearInterval(this.tm);
						this.tm = null;
					}
				}, 1000);
			}).catch(error => {
				this.$message({
				  type: 'error',
				  content: error
				})
			})
		},

    //重置密码验证码
    sendResetPwdVerificationCode(){
      if (this.tm) return false;
			if (!this.resetPwdAccount) {
				return this.$message({
				  type: 'error',
				  content: '请输入账号'
				})
			};
			
			sendResetPwdVerificationCode({
				account: this.resetPwdAccount
			}).then(() => {
				this.codeText = 60;
				this.tm = setInterval(() => {
					--this.codeText;
					if (this.codeText === 0) {
						this.codeText = '获取验证码';
						clearInterval(this.tm);
						this.tm = null;
					}
				}, 1000);
			}).catch(error => {
				this.$message({
				  type: 'error',
				  content: error
				})
			})
    },

    onSubmit() {
      if (this.operateType == 'register') {
				register({
					phone: this.phone,
					verificationCode: this.verificationCode
				}).then(() => {
					login({
					  account: this.phone,
					  password: '123456',
					  // rememberMe: "string"
					}).then(data => {
					  localStorage.setItem('token', data);
					  this.getUserInfo().then(() => {
					    router.replace('/');
					  });
					}).catch(error => {
            this.$message({
              type: 'error',
              content: error
            })
          })
				}).catch(error => {
					this.$message({
					  type: 'error',
					  content: error
					})
				})
      } else if(this.operateType == 'login') {
        login({
          account: this.account,
          password: this.password,
          // rememberMe: "string"
        }).then(data => {
          localStorage.setItem('token', data);
          this.getUserInfo().then(() => {
            if (this.checked) {
              localStorage.setItem('username', this.account);
              localStorage.setItem('password', this.password);
            } else {
              localStorage.removeItem('username');
              localStorage.removeItem('password');
            }
            router.replace('/');
          });
        }).catch(error => {
					this.$message({
					  type: 'error',
					  content: '账号密码错误'
					})
				})
      }else if(this.operateType == 'resetPwd'){
        resetPwd({
          account: this.resetPwdAccount,
          code: this.resetPwdVerificationCode,
          // rememberMe: "string"
        }).then(data => {
          this.$message({
					  type: 'success',
					  content: '已恢复初始密码，请重新登录'
					})
          localStorage.removeItem('username');
          localStorage.removeItem('password');
          this.operateType = 'login';
          this.account = '';
          this.password = '';
        }).catch(error => {
					this.$message({
					  type: 'error',
					  content: '账号密码错误'
					})
				})
      }

    }
  },
}
</script>

<style lang="less" scoped>
.login {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 111111;

  &-bg {
    width: 100%;
    height: 100%;
    background: url('http://ylxh-service.oss-cn-hangzhou.aliyuncs.com/login-bg.jpg') no-repeat center 0;
    // background: url(../../assets/images/login-bg.jpg) no-repeat center 0;
    
    background-size: 100% 100%;
  }

  &-content {
    position: absolute;
    right: 0;
    top: 0;
    min-width: 800px;
    height: 100%;
    background: url(../../assets/images/login-content-bg.png) no-repeat center 0;
    background-size: 100% 100%;
    padding: 70px 70px 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  &-header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo {
      height: 46px;

      > img {
        width: 267px;
        height: 100%;
      }
    }

    .menu-content {
      height: 100%;
      display: flex;
      align-items: center;

      > .menu-item {
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131415;
        margin-left: 20px;
        margin-top: 20px;
        cursor: pointer;

        &:hover {
          font-weight: 600;
          color: #06ae63;

          &::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: -7px;
            width: 100%;
            height: 4px;
            background: #06ae63;
          }
        }
      }
    }
  }

  &-main {
    width: 100%;
    padding: 43px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &-title {
    font-size: 38px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #131415;
    position: relative;
    margin-bottom: 118px;
    
    &::after {
      content: '';
      width: 100%;
      height: 16px;
      background: #06AE63;
      position: absolute;
      bottom: 0;
      left: 0;
      opacity: .8;
    }
  }

  &-form {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 108px;

    &-label {
      padding-left: 30px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #787878;
      margin-bottom: 16px;
    }

    &-item {
      width: 260px;
      height: 50px;
      background: #F5F5F5;
      border-radius: 30px;
      padding: 0 30px;
      display: flex;
      position: relative;

      input {
        flex: 1;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #131415;
        background: inherit;
      }

      .code-box {
        width: 100px;
        height: 100%;
        line-height: 50px;
        text-align: right;
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #06AE63;
        position: absolute;
        right: 30px;
        top: 0;
				
				&.disabled {
					// color: #787878;
          color: #06AE63;
				}
      }
    }
  }

  .login-submit {
    width: 360px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &-btn {
      width: 100%;
      height: 60px;
      background: #06AE63;
      border-radius: 30px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 60px;
      text-align: center;
      cursor: pointer;
      margin-bottom: 24px;
    }

    &-extra {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: 16px;

      &--simple {
        align-items: flex-end;
      }

      .login-extra-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .login-remeber {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #787878;
        white-space: nowrap;

        .sign-check {
          width: 18px;
          height: 18px;
          margin-right: 7px;
          flex-shrink: 0;
          background: url(../../assets/images/icon-no-checked.png) no-repeat center center;
          background-size: 100% 100%;

          &.checked {
            background-image: url(../../assets/images/icon-checked.png);
          }
        }
      }

      .login-forget {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #06AE63;
        text-decoration: underline;
        white-space: nowrap;
      }

      .login-register-links {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        flex-wrap: nowrap;

        .login-forget {
          font-size: 14px;
          text-decoration: none;
          padding: 7px 16px;
          border: 1px solid #06AE63;
          border-radius: 20px;
          line-height: 1.2;
          transition: background-color 0.2s, color 0.2s;

          &:hover {
            background: #06AE63;
            color: #fff;
          }
        }
      }
    }
  }

  &-footer {
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #131415; 
  }
}

.forget-tip-mask {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
}

.forget-tip-modal {
  width: 420px;
  padding: 36px 32px 28px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
  text-align: center;
  box-sizing: border-box;
}

.forget-tip-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 18px;
  border-radius: 50%;
  background: linear-gradient(135deg, #e8faf2 0%, #d4f5e4 100%);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    width: 28px;
    height: 28px;
    transform: translate(-50%, -50%);
    background: url(../../assets/images/icon-notice.svg) no-repeat center center;
    background-size: contain;
    filter: invert(48%) sepia(72%) saturate(500%) hue-rotate(100deg) brightness(95%);
  }
}

.forget-tip-title {
  margin-bottom: 10px;
  font-size: 22px;
  font-weight: 600;
  color: #131415;
  font-family: PingFangSC-Medium, PingFang SC;
}

.forget-tip-desc {
  margin-bottom: 8px;
  font-size: 18px;
  color: #06ae63;
  font-weight: 500;
  letter-spacing: 1px;
  font-family: PingFangSC-Medium, PingFang SC;
}

.forget-tip-phone {
  margin-bottom: 24px;
  font-size: 14px;
  color: #8c8c8c;
  line-height: 1.6;
}

.forget-tip-btn {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 22px;
  background: linear-gradient(135deg, #06ae63 0%, #0bc978 100%);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(6, 174, 99, 0.28);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(6, 174, 99, 0.36);
  }
}
</style>